import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from 'moment';

import { TextField, makeStyles, Button } from "@material-ui/core";
import ReCAPTCHA from "react-google-recaptcha";
import QrReader from "react-qr-reader";

import rewardActions from "../actions/rewards.actions";

import bgImg from "../assets/imgs/QR_bg_img.JPG";
import styled from "styled-components";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

const useBrandStyles = makeStyles((theme) => ({
  main: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    marginBottom: "20px",
    [theme.breakpoints.up("sm")]: {
      marginRight: "620px",
    },
  },
  campaignBanner: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  form: {
    padding: "20px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    background: "white",
  },
  submit: {
    marginTop: "10px",
    // width:"10%"
  },
  captch: {
    display: "flex",
    justifyContent: "center",
  },
}));

const StyledBtn = styled(Button)`
  color: #fff !important;
  border-color: #000 !important;
  background-color: #3f3f3f !important;
  padding-left: 25px;
  padding-right: 25px;
  margin: auto;
  display: block
`;

const StyledTextField = styled(TextField)`
  margin-bottom: 10px;
  background: white!important;
  border-color: black!important;
  * {
    border-color: black!important;
  }
  label {
    color: gray!important
  }
  input {
    color: black!important;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    transition: background-color 5000s ease-in-out 0s !important;
    -webkit-text-fill-color: black !important;
  }
`;

function RewardClaim() {
  const dispatch = useDispatch();
  let { brand_slug, reward_id, consumer_Id } = useParams();
  const classes = useBrandStyles();
  const rewardInfo = useSelector((state) => state.rewards.redeemRewardInfo);

  useEffect(() => {
    dispatch(rewardActions.getRedeemRewardInfo(brand_slug, reward_id, consumer_Id));
  }, [dispatch, reward_id, brand_slug]);

  return (
    <div style={{ height: "100%", background: "white", color: "black" }}>
      <div
        style={{
          backgroundSize: "cover",
          height: "150px",
          position: "relative",
        }}
      >
        {rewardInfo.company && (
          <div
            style={{
              height: "100px",
              width: "100px",
              bottom: "20px",
              margin: 'auto',
              paddingTop: '40px',
              left: "20px",
              textAlign: 'center'
            }}
          >
            <img
              src={`${rewardInfo.company.logo}`}
              alt="brand logo"
              style={{ width: "100%" }}
            />
          </div>
        )}
      </div>
      <div style={{ background: 'white' }}>
        {rewardInfo.campaign && rewardInfo.campaign.redemptionType === "online"
          ? rewardInfo.rewardGroup && (
            <Online
              description={rewardInfo.rewardGroup.itemDescription}
              instructions={rewardInfo.campaign.redemptionInstructions}
              terms={rewardInfo.campaign.terms}
              rewardInfo={rewardInfo}
              consumerId={consumer_Id}
            />
          )
          : rewardInfo.rewardGroup && (
            <Offline
              description={rewardInfo.rewardGroup.itemDescription}
              instructions={rewardInfo.campaign.redemptionInstructions}
              terms={rewardInfo.campaign.terms}
              rewardInfo={rewardInfo}
              consumerId={consumer_Id}
            />
          )}
      </div>
    </div>
  );
}

const useOnlineStyles = makeStyles({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  terms: {
    margin: '20px',
    marginRight: 'auto',
    whiteSpace: 'break-spaces',
    overflowWrap: 'anywhere',
    boxSizing: 'border-box'
  },
});

function Online({
  description,
  instructions,
  terms,
  rewardInfo,
  consumerId,
}) {
  const reCaptchaRef = useRef();
  const classes = useOnlineStyles();
  const dispatch = useDispatch();
  const [isSubscribed, setIsSubscribed] = useState('');
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const showGetRewardButton = useSelector(
    (state) => state.rewards.showGetRewardButton
  );
  const redeemData = useSelector((state) => state.rewards.reward);

  const handleSubmit = () => {
    setShowSubscriptionModal(true)
  };
  const handleClose = (value) => {
    setShowSubscriptionModal(false)
    setIsSubscribed(value);
    reCaptchaRef.current.execute();
  }
  let { brand_slug, reward_id, consumer_Id } = useParams();

  const onChange = (value) => {
    const payload = {
      campaignId: rewardInfo.campaign._id,
      brandSlug: rewardInfo.company.brandSlug,
      consumerId: consumerId,
      rewardId: reward_id,
      gRecaptchaResponse: value,
      isSubscribed: isSubscribed
    };
    dispatch(rewardActions.postRewardDetails(payload));
  };
  var claimLabel = "";
  var redeemLabel = "";
  var redemptionCode = "";
  if (redeemData && Object.keys(redeemData).length > 0) {
    claimLabel = moment(redeemData.claimedAt).format('DD/MM/YYYY hh:mm a');
    redeemLabel = moment(redeemData.redeemedAt).format('DD/MM/YYYY hh:mm a');
    redemptionCode = redeemData.redemptionCode;
  } else if (rewardInfo.reward.redeemedAt) {
    claimLabel = moment(rewardInfo.reward.claimedAt).format('DD/MM/YYYY hh:mm a');
    redeemLabel = moment(rewardInfo.reward.redeemedAt).format('DD/MM/YYYY hh:mm a');
    redemptionCode = rewardInfo.reward.redemptionCode;
  }
  return (
    <div className={classes.root}>
      <Dialog
        open={showSubscriptionModal}
        onClose={handleClose}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Subscribe updates"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you want to receive future updates and promotions from {rewardInfo.company.brandName}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose('no')} color="primary">
            Disagree
          </Button>
          <Button onClick={() => handleClose('yes')} color="primary" autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
      <p style={{ padding: 0, margin: '20px' }}>Congrats! You have received following reward from {rewardInfo.company.brandName}</p>
      <h3 style={{ padding: 0, margin: '10px' }}>{description}</h3>
      <div style={{ width: '100%' }}>
        {((redeemData && Object.keys(redeemData).length > 0) || (rewardInfo.reward.redeemedAt)) ? (
          <>
            <h3 style={{ textAlign: 'center', margin: 0, marginBottom: "10px" }}>Successfully Redeemed.</h3>
            <h5 style={{ textAlign: 'center', margin: '10px', fontSize: '17px', marginBottom: '14px' }}>Redemption Code: {redemptionCode}</h5>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: "0 20px", width: '100%', boxSizing: 'border-box' }}>
              <h4 style={{ textAlign: 'left', marginTop: 0, marginBottom: 0 }}>Claimed At: <p style={{ fontWeight: 400, fontSize: '12px' }}>{claimLabel}</p></h4>
              <h4 style={{ textAlign: 'right', marginTop: 0, marginBottom: 0 }}>Redeemed At: <p style={{ fontWeight: 400, fontSize: '12px' }}>{redeemLabel}</p></h4>
            </div>
          </>
        ) : <>{showGetRewardButton && (
          <StyledBtn
            color="primary"
            variant="contained"
            type="submit"
            onClick={() => handleSubmit()}
          >
            GET REDEMPTION CODE
          </StyledBtn>
        )}</>}
        <ReCAPTCHA
          ref={reCaptchaRef}
          sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
          size="invisible"
          onChange={onChange}
        />
      </div>
      <div className={classes.terms}>
        <h4>Redemption Instructions:</h4>
        <div style={{ padding: '0 5px' }}>
          {rewardInfo && rewardInfo.rewardGroup && rewardInfo.rewardGroup.rewardPage && <a target="_blank" href={rewardInfo.rewardGroup.rewardPage}>Click here to redeem</a>}
          { ReactHtmlParser(instructions) }
        </div>
        {
          terms &&
          <React.Fragment>
            <h4>Terms & Conditions:</h4>
            <div style={{ padding: '0 5px' }}>
              { ReactHtmlParser(terms) }
            </div>
          </React.Fragment>
        }
      </div>
    </div>
  );
}

function Offline({
  description,
  instructions,
  terms,
  rewardInfo,
  consumerId,
}) {
  const [redemptionCodeValue, setredemptionValue] = useState("");
  const [isQRCodeReaderOpen, setQRCodeReaderOpen] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState('');
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const dispatch = useDispatch();
  const handleScan = (data) => {
    if (data) {
      setQRCodeReaderOpen(false)
      setredemptionValue(data);
      setShowSubscriptionModal(true)
      // reCaptchaRef.current.execute();
    }
  };
  const handleError = (err) => {
    alert(err);
  };
  const handleClose = (value) => {
    setShowSubscriptionModal(false)
    setIsSubscribed(value);
    reCaptchaRef.current.execute();
  }
  const reCaptchaRef = useRef();
  let { brand_slug, reward_id, consumer_Id } = useParams();

  const onChange = (value) => {
    const payload = {
      campaignId: rewardInfo.campaign._id,
      companyId: JSON.parse(redemptionCodeValue).key,
      brandSlug: rewardInfo.company.brandSlug,
      consumerId: consumerId,
      rewardId: reward_id,
      gRecaptchaResponse: value,
      isSubscribed: isSubscribed
    };
    dispatch(rewardActions.postRewardDetails(payload));
  }

  const redeemData = useSelector((state) => state.rewards.reward);

  const classes = useOnlineStyles();
  console.log(rewardInfo.reward, redeemData)
  var claimLabel = "";
  var redeemLabel = ""
  if (redeemData && Object.keys(redeemData).length > 0) {
    claimLabel = moment(redeemData.claimedAt).format('DD/MM/YYYY hh:mm a');
    redeemLabel = moment(redeemData.redeemedAt).format('DD/MM/YYYY hh:mm a');
  } else if (rewardInfo.reward.redeemedAt) {
    claimLabel = moment(rewardInfo.reward.claimedAt).format('DD/MM/YYYY hh:mm a');
    redeemLabel = moment(rewardInfo.reward.redeemedAt).format('DD/MM/YYYY hh:mm a');
  }
  return (
    <>
      {
        !isQRCodeReaderOpen &&
        <div className={classes.root}>
          <Dialog
            open={showSubscriptionModal}
            onClose={handleClose}
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Subscribe updates"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Do you want to receive future updates and promotions from {rewardInfo.company.brandName}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => handleClose('no')} color="primary">
                Disagree
          </Button>
              <Button onClick={() => handleClose('yes')} color="primary" autoFocus>
                Agree
          </Button>
            </DialogActions>
          </Dialog>
          <p style={{ padding: 0, margin: '20px' }}>Congrats! You have received following reward from {rewardInfo.company.brandName}</p>
          <h3 style={{ padding: 0, margin: '10px' }}>{description}</h3>
          {
            ((redeemData && Object.keys(redeemData).length > 0) || (rewardInfo.reward.redeemedAt)) ?
              <>
                <h3 style={{ textAlign: 'center', margin: 0, marginBottom: "10px" }}>Successfully Redeemed.</h3>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: "0 20px", width: '100%', boxSizing: 'border-box' }}>
                  <h4 style={{ textAlign: 'left', marginTop: 0, marginBottom: 0 }}>Claimed At: <p style={{ fontWeight: 400, fontSize: '12px' }}>{claimLabel}</p></h4>
                  <h4 style={{ textAlign: 'right', marginTop: 0, marginBottom: 0 }}>Redeemed At: <p style={{ fontWeight: 400, fontSize: '12px' }}>{redeemLabel}</p></h4>
                </div>
              </>
              :
              <>
                <StyledBtn
                  color="primary"
                  variant="contained"
                  type="submit"
                  onClick={() => setQRCodeReaderOpen(true)}
                >
                  Click to Scan
              </StyledBtn>
                <p style={{ margin: '20px 20px 0 20px' }}>Scan Merchant's QR Code at the provided location to redeem your reward.</p>
              </>
          }
          <div>
            <ReCAPTCHA
              ref={reCaptchaRef}
              sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
              size="invisible"
              onChange={onChange}
            />
          </div>
          <div className={classes.terms}>
            <h4>Redemption Location</h4>
            <div style={{ padding: '0 5px' }}>
                  <p>{rewardInfo.campaign.redemptionLocation}</p>
            </div>
  
            <h4>Redemption Instructions:</h4>
              <div style={{ padding: '0 5px' }}>
                  { ReactHtmlParser(instructions) }
              </div>
            {
              terms &&
              <React.Fragment>
                <h4>Terms & Conditions:</h4>
                <div style={{ padding: '0 5px' }}>
                  { ReactHtmlParser(terms) }
                </div>
              </React.Fragment>
            }
          </div>
        </div>
      }
      {
        isQRCodeReaderOpen &&
        <div style={{
          position: 'fixed', top: 0, right: 0,
          left: 0, bottom: 0
        }}>
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "#525252", zIndex: 2, opacity: 0.7 }}>
          </div>
          <QrReader
            delay={300}
            onError={handleError}
            onScan={handleScan}
            style={{ width: "100%", position: 'fixed', zIndex: 33, top: '20%' }}
          />
        </div>
      }
    </>
  );
}

export default RewardClaim;
